import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiAuthorSkillVariables = Types.Exact<{
  input: Types.AIAuthorSkillInput;
}>;

export type RunAiAuthorSkill = {
  aiAuthorSkill: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiAuthorSkillDocument = gql`
  mutation RunAiAuthorSkill($input: AIAuthorSkillInput!) {
    aiAuthorSkill(input: $input) {
      streamName
      streamId
      pinned
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiAuthorSkillMutationFn = Apollo.MutationFunction<
  RunAiAuthorSkill,
  RunAiAuthorSkillVariables
>;

/**
 * __useRunAiAuthorSkill__
 *
 * To run a mutation, you first call `useRunAiAuthorSkill` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiAuthorSkill` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiAuthorSkill, { data, loading, error }] = useRunAiAuthorSkill({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiAuthorSkill(
  baseOptions?: Apollo.MutationHookOptions<RunAiAuthorSkill, RunAiAuthorSkillVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAiAuthorSkill, RunAiAuthorSkillVariables>(
    RunAiAuthorSkillDocument,
    options,
  );
}
export type RunAiAuthorSkillHookResult = ReturnType<typeof useRunAiAuthorSkill>;
export type RunAiAuthorSkillMutationResult = Apollo.MutationResult<RunAiAuthorSkill>;
export type RunAiAuthorSkillMutationOptions = Apollo.BaseMutationOptions<
  RunAiAuthorSkill,
  RunAiAuthorSkillVariables
>;
export function mockRunAiAuthorSkill({
  data,
  variables,
  errors,
}: {
  data: RunAiAuthorSkill;
  variables?: RunAiAuthorSkillVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiAuthorSkillDocument, variables },
    result: { data, errors },
  };
}
